'use strict';

var MarketAnalysisGridController = function MarketAnalysisGridController($scope, reoptimizationService, scenarioService, dataRetrieverService) {
  $scope.cogOptions = require('../config/cogOptions');
  $scope.$on('reoptimizeMarketGrid', function (event, selectedRows) {
    reoptimizationService.reoptimizeFromMarketScreen(selectedRows, scenarioService.getSelectedScenarioName());
  });
  dataRetrieverService.getDataRetriever($scope.screen, $scope.mode).isQueryingMoreDomains(!$scope.isDemandManagement);
};
MarketAnalysisGridController.$inject = ['$scope', 'ReoptimizationService', 'ScenarioService', 'DataRetrieverService'];
module.exports = MarketAnalysisGridController;